import { isMobile, isIPhone13, isMobileSafari, isMobileOnly } from 'react-device-detect';

export default class DeviceDetect {
    public static isMobileDevice = () => {
        const cMaxScreenSizeMobile = 1100;
        return isMobile || isIPhone13 || isMobileSafari || isMobileOnly
//            || window.innerWidth < cMaxScreenSizeMobile || window.innerHeight < cMaxScreenSizeMobile
            ;
    }
}

export const isMobileDevice = DeviceDetect.isMobileDevice();
